import { IAPIClient } from './IAPIClient';
import * as yup from 'yup';

export interface IAgentEditClient extends IAPIClient {
    post(input: IPostInput): Promise<IPostResponse>;
}

export const AgentEditSchema = yup.object({
    agent_type: yup.string().required(),
    is_sole_proprietor: yup.boolean().required().default(false),
    name: yup.string().required(),
    company_code: yup.string().matches(/^[0-9]+$/, '半角数字のみ入力可能です'),
    regions_served: yup.array().of(yup.string().required()).required().default([]),
    industries_served: yup.array().of(yup.string().required()).required().default([]),
    number_of_employees: yup.string().required(),
    icon_image: yup.string().nullable(),
    business_description: yup.string().required(),
    question: yup.string().nullable(),
    hp_url: yup.string().nullable(),
    billing_address: yup.string().required(),
    billing_zipcode: yup.string().required(),
    billing_name: yup.string().required(),
    billing_phone: yup.string().required().max(30).onlyNumber(),
    billing_email: yup.string().email().required(),
    private: yup.boolean().required().default(false),
});
type IAgent = yup.InferType<typeof AgentEditSchema>;

export interface IPostInput {
    token: string;
    agent: IAgent;
}

export const PostOutput = yup
    .object({
        data: yup.object().required(),
        message: yup.string().optional(),
    })
    .required();
export type IPostResponse = Readonly<yup.InferType<typeof PostOutput>>;
